export default __webpack_public_path__ + "static/media/settings.774d531e.svg";